// load required modules
import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import set from "@rill/set";
import SettingsNav from "../../../parts/settings-nav";
import CancelAccountModal from "../../../parts/modals/cancel-account";
import UpdatePaymentModal from "../../../parts/modals/update-payment";
import UpgradeConfirmationModal from "../../../parts/modals/upgrade-confirmation";
import PlanSwitchConfirmation from "../../../parts/modals/plan-switch-confirmation";
import { US_STATES, AU_STATES } from "../../../constants";

class ManageSubscription extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handlePeriodToggle = this.handlePeriodToggle.bind(this);
    this.handlePlanTypeToggle = this.handlePlanTypeToggle.bind(this);
    this.handleCountrySelect = this.handleCountrySelect.bind(this);
  }

  componentWillMount() {
    const { locals } = this.context;
    const { momentTZ, query, activeUser, activeUserToRequest } = locals;

    // Describe user's current stripe plan and status
    const currentPlan = get(
      activeUserToRequest,
      "stripe.plan",
      "launch_freeTrial"
    );
    const isStandard =
      currentPlan === "v2_standard_monthly" ||
      currentPlan === "v2_standard_annually";
    const isAnnually =
      currentPlan === "v2_standard_annually" ||
      currentPlan === "v2_premium_annually";

    const selectedPlanType = isStandard ? "standard" : "premium";

    this.setState({
      payPeriod: isAnnually ? "annually" : "monthly",
      selectedPlanType,
      plan: this.getPlan(isAnnually ? "annually" : "monthly", selectedPlanType),
      countrySelected: activeUser.country || "CA",
    });
  }

  handlePeriodToggle(e) {
    const payPeriod =
      this.state.payPeriod === "monthly" ? "annually" : "monthly";

    // Only setState if there is a change in the plan selected
    if (payPeriod === e.target.value) {
      this.setState({
        payPeriod,
        plan: this.getPlan(payPeriod, this.state.selectedPlanType),
      });
    }
  }

  handlePlanTypeToggle(e) {
    const selectedPlanType =
      this.state.selectedPlanType === "premium" ? "standard" : "premium";

    // Only setState if there is a change in the plan selected
    if (selectedPlanType === e.target.value) {
      this.setState({
        selectedPlanType,
        plan: this.getPlan(this.state.payPeriod, selectedPlanType),
      });
    }
  }

  handleCountrySelect(e) {
    this.setState({ countrySelected: e.target.value });
  }

  getPlan(payPeriod, selectedPlanType) {
    let plan = "";
    if (payPeriod === "monthly") {
      plan =
        selectedPlanType === "standard"
          ? "v2_standard_monthly"
          : "v2_premium_monthly";
    } else {
      plan =
        selectedPlanType === "standard"
          ? "v2_standard_annually"
          : "v2_premium_annually";
    }
    return plan;
  }

  render() {
    const { locals } = this.context;
    const {
      query,
      momentTZ,
      getCountryName,
      countries: countryOptions,
      activeUser,
    } = locals;
    const currentPlan = get(
      locals.activeUserToRequest,
      "stripe.plan",
      "launch_freeTrial"
    );
    const isFreeTrial =
      currentPlan === "launch_freeTrial" || currentPlan === "free_trial";
    const isStandard =
      currentPlan === "v2_standard_monthly" ||
      currentPlan === "v2_standard_annually";
    const isPremium =
      currentPlan === "v2_premium_monthly" ||
      currentPlan === "v2_premium_annually";
    const isAnnually =
      currentPlan === "v2_standard_annually" ||
      currentPlan === "v2_premium_annually";

    const freeTrialEndDate = momentTZ(
      get(locals.activeUserToRequest, "stripe.period_end")
    );
    const finalRententionDate = freeTrialEndDate
      .clone()
      .add(60, "days")
      .endOf("day")
      .add(1, "second");
    const card = get(locals.activeUserToRequest, "stripe.card");
    const hasCreditCard = Boolean(card && card.brand);
    const coupon =
      query.coupon || get(locals, "activeUserToRequest.stripe.coupon");
    const couponError = query.couponError;
    const hasCoupon = Boolean(get(coupon, "id"));
    const hasCouponError = Boolean(couponError);
    const isCouponApplied =
      get(coupon, "id") === get(locals, "activeUserToRequest.stripe.coupon.id");
    const isCancelled = locals.activeUser.cancelled;

    return (
      <main className="Main Settings-Billing">
        <SettingsNav />

        <div className="Content">
          <form method="POST" data-noreset>
            <div className="frame alt">
              <input type="hidden" name="plan" value={this.state.plan} />

              <div className="head">
                <h1 className="alt">
                  {isFreeTrial ? "Upgrade Account" : "Manage Subscription"}
                </h1>
              </div>

              <div className="columns">
                <div className="column" data-col="1/2">
                  <div className="Payment-Selector-2">
                    <label className="plan">
                      <input
                        type="radio"
                        name="plan"
                        defaultChecked={
                          this.state.selectedPlanType === "standard"
                        }
                        onClick={(e) => this.handlePlanTypeToggle(e)}
                        value="standard"
                      />
                      <span className="details">
                        <span className="radio" />
                        <span className="text">Standard</span>
                        {isPremium && (
                          <span className="downgrade">Downgrade</span>
                        )}
                        {isFreeTrial && (
                          <span className="upgrade">Upgrade</span>
                        )}
                        {!(isStandard || isFreeTrial) && (
                          <span className="downgrade">Downgrade</span>
                        )}
                      </span>
                      {isStandard && (
                        <span className="message">
                          {isCancelled
                            ? `Ends ${momentTZ(
                                activeUserToRequest.stripe.period_end
                              ).format("DD/MM/YYYY")}`
                            : "YOUR SUBSCRIPTION"}
                        </span>
                      )}
                    </label>

                    <label className="plan">
                      <input
                        type="radio"
                        name="plan"
                        defaultChecked={
                          this.state.selectedPlanType === "premium"
                        }
                        onClick={(e) => this.handlePlanTypeToggle(e)}
                        value="premium"
                      />
                      <span className="details">
                        <span className="radio" />
                        <span className="text">Premium </span>
                        <span className="upgrade">Upgrade</span>
                      </span>

                      {isPremium && (
                        <span className="message">
                          {isCancelled
                            ? `Ends ${momentTZ(
                                activeUserToRequest.stripe.period_end
                              ).format("DD/MM/YYYY")}`
                            : "YOUR SUBSCRIPTION"}
                        </span>
                      )}
                    </label>

                    <label className="plan">
                      <input
                        type="radio"
                        name="cycle"
                        defaultChecked={!isAnnually}
                        onClick={(e) => this.handlePeriodToggle(e)}
                        value="monthly"
                      />
                      <span className="details">
                        <span className="radio" />
                        <span className="text">Billed Monthly</span>
                        <span className="price">
                          $
                          {this.state.selectedPlanType === "standard"
                            ? "9.00"
                            : "29.00"}{" "}
                          USD
                        </span>
                      </span>
                    </label>

                    <label className="plan">
                      <input
                        type="radio"
                        name="cycle"
                        onClick={(e) => this.handlePeriodToggle(e)}
                        defaultChecked={isAnnually}
                        value="annually"
                      />
                      <span className="details">
                        <span className="radio" />
                        <span className="text">Billed Annually</span>
                        <span className="rebate">10% off</span>
                        <span className="price">
                          $
                          {this.state.selectedPlanType === "standard"
                            ? "97.20"
                            : "313.20"}{" "}
                          USD
                        </span>
                      </span>
                    </label>
                  </div>
                </div>

                {hasCreditCard ? (
                  <div>
                    {/* Coupon Section Start */}
                    {hasCoupon ? (
                      <div className="column" data-col="1/2">
                        <div className="column" data-col="2/3">
                          <div className="label">Coupon Code</div>
                          <input
                            className="text-input fs-hide"
                            type="text"
                            name="couponCode"
                            defaultValue={coupon.id}
                            readOnly={isCouponApplied}
                          />
                          {hasCouponError ? (
                            <div className="coupon-msg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                              >
                                <g fill="#E23914">
                                  <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                                  <polygon points="13 11.6 8.5 7.1 7.1 8.5 11.6 13 7.1 17.5 8.5 18.9 13 14.4 17.5 18.9 18.9 17.5 14.4 13 18.9 8.5 17.5 7.1" />
                                </g>
                              </svg>
                              {couponError}
                            </div>
                          ) : (
                            <div className="coupon-msg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                              >
                                <g fill="#75C454">
                                  <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                                  <polygon points="11.5 16 6.5 11.1 5.1 12.5 10.1 17.5 10.1 17.6 10.8 18.2 11.5 18.9 11.5 18.9 11.6 18.9 12.2 18.2 12.9 17.5 12.9 17.5 20.4 8.9 18.9 7.6 11.5 16" />
                                </g>
                              </svg>
                              {coupon.description}
                            </div>
                          )}
                        </div>
                        <div className="column" data-col="1/3">
                          <div className="label" />
                          {isCouponApplied ? (
                            <button
                              type="submit"
                              name="button"
                              value="remove-coupon"
                            >
                              Remove
                            </button>
                          ) : (
                            <button
                              className="button-input full alt"
                              type="submit"
                              name="button"
                              value="validate-coupon"
                            >
                              Validate
                            </button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="column" data-col="1/2">
                        <div className="column" data-col="2/3">
                          <div className="label">Coupon Code</div>
                          <input
                            className="text-input fs-hide"
                            type="text"
                            name="couponCode"
                          />
                          {hasCouponError && (
                            <div className="coupon-msg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                              >
                                <g fill="#E23914">
                                  <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                                  <polygon points="13 11.6 8.5 7.1 7.1 8.5 11.6 13 7.1 17.5 8.5 18.9 13 14.4 17.5 18.9 18.9 17.5 14.4 13 18.9 8.5 17.5 7.1" />
                                </g>
                              </svg>
                              {couponError}
                            </div>
                          )}
                        </div>
                        <div className="column" data-col="1/3">
                          <div className="label" />
                          <button
                            className="button-input full alt"
                            type="submit"
                            name="button"
                            value="validate-coupon"
                          >
                            Validate
                          </button>
                        </div>
                      </div>
                    )}
                    {/* Coupon Section End */}
                    <div className="column" data-col="1/2" />
                    {/* Payment Info Start */}
                    <div className="column" data-col="1/2">
                      <div className="label">Credit Card</div>
                      <div className="cc-brand-element">
                        <div>
                          <label className="radio-input">
                            <input type="radio" defaultChecked />
                            <span className="radio" />
                          </label>
                          <div
                            className="cc-brand"
                            style={{
                              WebkitMask: `url(/img/${card.brand
                                .replace(" ", "-")
                                .toLowerCase()}-icon.svg) no-repeat center`,
                              mask: `url(/img/${card.brand
                                .replace(" ", "-")
                                .toLowerCase()}-icon.svg) no-repeat center`,
                            }}
                          />
                        </div>
                        <b>{`**** **** **** ${card.lastFour}`}</b>
                      </div>
                    </div>
                    {/* Payment Info End */}
                  </div>
                ) : (
                  <div>
                    {/* Billing Address Start */}
                    <div className="column" data-col="1/2">
                      <div className="label">Billing Address</div>
                      <input
                        className="text-input"
                        name="source[address_line1]"
                        type="text"
                        placeholder="Address Line 1"
                      />
                    </div>
                    <div className="column" data-col="1/2" />
                    <div className="column" data-col="1/2">
                      <input
                        className="text-input"
                        name="source[address_line2]"
                        type="text"
                        placeholder="Address Line 2"
                      />
                    </div>
                    <div className="column" data-col="1/2" />
                    <div className="column" data-col="1/2">
                      <div className="column" data-col="1/3">
                        <input
                          className="text-input"
                          name="source[address_city]"
                          type="text"
                          placeholder="City"
                        />
                      </div>

                      {this.state.countrySelected === "CA" && (
                        <div className="column" data-col="1/3">
                          <select
                            className="select-input"
                            type="text"
                            name="source[address_state]"
                            placeholder="Province"
                          >
                            <option disabled value="">
                              Province
                            </option>
                            <option value="AB">Alberta</option>
                            <option value="BC">British Columbia</option>
                            <option value="MB">Manitoba</option>
                            <option value="NB">New Brunswick</option>
                            <option value="NL">
                              Newfoundland and Labrador
                            </option>
                            <option value="NS">Nova Scotia</option>
                            <option value="ON">Ontario</option>
                            <option value="PE">Prince Edward Island</option>
                            <option value="QC">Quebec</option>
                            <option value="SK">Saskatchewan</option>
                            <option value="NT">Northwest Territories</option>
                            <option value="NU">Nunavut</option>
                            <option value="YT">Yukon</option>
                          </select>
                        </div>
                      )}

                      {this.state.countrySelected === "US" && (
                        <div className="column" data-col="1/3">
                          <select
                            className="select-input"
                            type="text"
                            name="source[address_state]"
                          >
                            <option disabled value="">
                              State
                            </option>
                            {US_STATES.map((state) => (
                              <option value={state.abbreviation}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {this.state.countrySelected === "AU" && (
                        <div className="column" data-col="1/3">
                          <select
                            className="select-input"
                            type="text"
                            name="source[address_state]"
                            defaultValue=""
                          >
                            <option disabled value="">
                              State
                            </option>
                            {AU_STATES.map((state) => (
                              <option value={state.abbreviation}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {["AU", "CA", "US"].indexOf(this.state.countrySelected) ==
                        -1 && (
                        <div className="column" data-col="1/3">
                          <input
                            className="text-input"
                            name="source[address_state]"
                            type="text"
                            placeholder="State"
                          />
                        </div>
                      )}

                      <div className="column" data-col="1/3">
                        <input
                          className="text-input"
                          name="source[address_zip]"
                          type="text"
                          placeholder={
                            this.state.countrySelected === "US"
                              ? "Zip Code"
                              : "Postal Code"
                          }
                        />
                      </div>
                    </div>
                    <div className="column" data-col="1/2" />
                    <div className="column" data-col="1/2">
                      <select
                        name="source[address_country]"
                        className="select-input"
                        defaultValue={get(activeUser, "country", "")}
                        onChange={(e) => this.handleCountrySelect(e)}
                      >
                        <option hidden disabled value="">
                          Location
                        </option>
                        {map(countryOptions, (code) => {
                          return (
                            <option key={code} value={code}>
                              {getCountryName(code)}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="column" data-col="1/2" />
                    {/* Billing Address End */}
                    {/* Payemnt Info Start */}
                    <div className="column" data-col="1/2">
                      <div className="label">Credit Card Number</div>
                      <input
                        type="text"
                        name="source[number]"
                        className="text-input fs-hide"
                        placeholder="Credit Card Number"
                      />
                    </div>
                    <div className="column" data-col="1/2" />

                    <div className="column" data-col="1/4">
                      <div className="label">Expiry</div>
                      <input
                        type="text"
                        name="source[exp]"
                        className="text-input fs-hide"
                        placeholder="MM/YY"
                      />
                    </div>

                    <div className="column" data-col="1/4">
                      <div className="label">Security&nbsp;Code</div>
                      <input
                        type="text"
                        name="source[cvc]"
                        className="text-input fs-hide"
                        placeholder="CVC"
                      />
                    </div>
                    {/* Payemnt Info End */}
                    {/* Coupon Section Start */}
                    <div className="column" data-col="1/2" />
                    {hasCoupon ? (
                      <div className="column" data-col="1/2">
                        <div className="column" data-col="2/3">
                          <div className="label">Coupon Code</div>
                          <input
                            className="text-input fs-hide"
                            type="text"
                            name="couponCode"
                            defaultValue={coupon.id}
                            readOnly={isCouponApplied}
                          />
                          {hasCouponError ? (
                            <div className="coupon-msg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                              >
                                <g fill="#E23914">
                                  <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                                  <polygon points="13 11.6 8.5 7.1 7.1 8.5 11.6 13 7.1 17.5 8.5 18.9 13 14.4 17.5 18.9 18.9 17.5 14.4 13 18.9 8.5 17.5 7.1" />
                                </g>
                              </svg>
                              {couponError}
                            </div>
                          ) : (
                            <div className="coupon-msg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                              >
                                <g fill="#75C454">
                                  <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                                  <polygon points="11.5 16 6.5 11.1 5.1 12.5 10.1 17.5 10.1 17.6 10.8 18.2 11.5 18.9 11.5 18.9 11.6 18.9 12.2 18.2 12.9 17.5 12.9 17.5 20.4 8.9 18.9 7.6 11.5 16" />
                                </g>
                              </svg>
                              {coupon.description}
                            </div>
                          )}
                        </div>
                        <div className="column" data-col="1/3">
                          <div className="label" />
                          {isCouponApplied ? (
                            <button
                              type="submit"
                              name="button"
                              value="remove-coupon"
                            >
                              Remove
                            </button>
                          ) : (
                            <button
                              className="button-input full alt"
                              type="submit"
                              name="button"
                              value="validate-coupon"
                            >
                              Validate
                            </button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="column" data-col="1/2">
                        <div className="column" data-col="2/3">
                          <div className="label">Coupon Code</div>
                          <input
                            className="text-input fs-hide"
                            type="text"
                            name="couponCode"
                          />
                          {hasCouponError && (
                            <div className="coupon-msg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                              >
                                <g fill="#E23914">
                                  <path d="M13 24C19.1 24 24 19.1 24 13 24 6.9 19.1 2 13 2 6.9 2 2 6.9 2 13 2 19.1 6.9 24 13 24ZM13 26C5.8 26 0 20.2 0 13 0 5.8 5.8 0 13 0 20.2 0 26 5.8 26 13 26 20.2 20.2 26 13 26Z" />
                                  <polygon points="13 11.6 8.5 7.1 7.1 8.5 11.6 13 7.1 17.5 8.5 18.9 13 14.4 17.5 18.9 18.9 17.5 14.4 13 18.9 8.5 17.5 7.1" />
                                </g>
                              </svg>
                              {couponError}
                            </div>
                          )}
                        </div>
                        <div className="column" data-col="1/3">
                          <div className="label" />
                          <button
                            className="button-input full alt"
                            type="submit"
                            name="button"
                            value="validate-coupon"
                          >
                            Validate
                          </button>
                        </div>
                        {/* Coupon Section End */}
                      </div>
                    )}
                  </div>
                )}

                <div className="column" data-col="1/2">
                  {!isCancelled && (
                    <a
                      href="/actions/refresh?modal[type]=cancel"
                      className="cancel"
                    >
                      Cancel Subscription
                    </a>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    );
  }
}

const SubscriptionController = (app) => {
  app.get(
    "/subscription",
    set("heading", "Manage Subscription"),
    async ({ res, req, locals, load }) => {
      const { query } = req;

      await load("activeUser", { user: locals.activeUser._id });

      // load modal component
      const modal = get(query, "modal", {});
      locals.modal = {
        cancel: <CancelAccountModal />,
        "update-payment": <UpdatePaymentModal />,
        "upgrade-confirmation": <UpgradeConfirmationModal />,
        "plan-switch-confirmation": <PlanSwitchConfirmation />,
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      if (modal.type === "plan-switch-confirmation")
        await load("invoice", { user: locals.activeUser._id });

      // return the react component
      res.body = (
        <ManageSubscription
          showCard={query.action === "updateCard" ? true : false}
        />
      );
    }
  );
};

export default SubscriptionController;
